import React from "react";
import moment from "moment";
import { AppShape } from "@eave/shared/types/api";
import { connect } from "react-redux";
import { loadApp } from "underwriter_dashboard/actions";
import WorksheetTable from "web_modules/shared/carbon/Worksheets/WorksheetTable";
import { ENUM, WorksheetName, WS_NAME } from "underwriter_dashboard/shared/WorksheetEditor/wsDefs";
import {
  notDash,
  notEmpty,
} from "underwriter_dashboard/shared/WorksheetEditor/wsValidationHelpers";
import { CarbonInputGenerationParams } from "web_modules/shared/carbon-types";
import { loadProrations, prorationsHeaderData, prorationToRow } from "./shared";
import { validCurrencyInputsOnly } from "@eave/shared/utils/numbers";

interface Props {
  app: AppShape;
  loadApp: Function;
}

class Prorations extends React.Component<Props, any> {
  constructor(props: Props) {
    super(props);
  }

  render() {
    const { app, loadApp } = this.props;

    const modalFields: CarbonInputGenerationParams[] = [
      {
        name: "description",
        type: "text",
        label: "Description",
        placeholder: "",
      },
      {
        name: "type",
        type: "select",
        label: "Type",
        options: ["-", ...ENUM.PRORATION_ITEM.map(String)],
        validation: notDash,
      },
      {
        name: "period_covered_start_date",
        type: "date",
        label: "Period covered start date",
        placeholder: "",
        beforeHandle: value => {
          if (value === "") {
            return null;
          }

          return moment(value).format("YYYY-MM-DD");
        },
      },
      {
        name: "period_covered_end_date",
        type: "date",
        label: "Period covered end date",
        placeholder: "",
        beforeHandle: value => {
          if (value === "") {
            return null;
          }

          return moment(value).format("YYYY-MM-DD");
        },
      },
      {
        name: "cd_amount",
        type: "text",
        label: "CD Amount",
        placeholder: "100",
        beforeHandle: validCurrencyInputsOnly,
        validation: v => {
          const notEmptyMsg = notEmpty(v);
          if (notEmptyMsg !== "") {
            return notEmptyMsg;
          }

          // not a perfect $ input regex, so not extracting.
          // but good enough for this use case.
          const validPattern = /^-?\d*\.?\d{0,2}$/;
          if (!validPattern.test(v)) {
            return "Only include numbers, with up to 2 decimal places (eg -4.05, 1,000)";
          }

          return "";
        },
      },
    ];

    const shared = {
      app,
      headerData: prorationsHeaderData,
      loadApp,
      modalFields,
      wsName: WS_NAME.PRORATIONS as WorksheetName,
      wsRecordName: WS_NAME.PRORATION as WorksheetName,
      worksheetToRow: prorationToRow,
      worksheetToFormState: loadProrations,
    };

    return (
      <div>
        <WorksheetTable
          title="Prorations: Paid By Seller"
          wsSliceName="paid_by_seller"
          {...shared}
        />
        <WorksheetTable
          title="Prorations: Unpaid By Seller"
          wsSliceName="unpaid_by_seller"
          {...shared}
        />
      </div>
    );
  }
}

const mapDispatchToProps = (dispatch, ownProps) => ({
  app: ownProps.app,
  loadApp: appID => {
    loadApp(dispatch, appID);
  },
});

export default connect(null, mapDispatchToProps)(Prorations);
